import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import type { ControlledFieldProps, FormFieldBaseProps } from '../../types'
import styles from './Checkbox.module.scss'

type CheckboxProps = FormFieldBaseProps & {
  placeholder?: string
  value?: boolean
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  isIndeterminate?: boolean
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      error,
      fieldClassName,
      id,
      name,
      placeholder,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isIndeterminate = false,
      isRequired = false,
    },
    ref,
  ) => {
    React.useEffect(() => {
      if (
        isIndeterminate != null &&
        ref &&
        typeof ref !== 'function' &&
        ref.current
      ) {
        ref.current.indeterminate = isIndeterminate
      }
    }, [ref, isIndeterminate])

    return (
      <input
        className={cx(styles.checkbox, fieldClassName, {
          [styles.invalid]: Boolean(error),
        })}
        type="checkbox"
        checked={value}
        disabled={isDisabled}
        required={isRequired}
        {...{ id, name, placeholder, ref, onBlur, onChange }}
      />
    )
  },
)

type ControlledCheckboxProps = ControlledFieldProps

export const ControlledCheckbox = ({
  control,
  error,
  fieldClassName,
  id,
  name,
  isDisabled,
  isRequired,
}: ControlledCheckboxProps) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Checkbox
        {...{
          error,
          fieldClassName,
          id,
          name,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
